import React, { useState } from 'react';
import { Plus, List, Users, Calendar } from 'lucide-react';
import Newemployeeform from './Newemployeeform';
import EmployeesList from './EmployeesList';
import CongesModule from './RH/CongesModule';
import { useFeatureFlag } from '../hooks/useFeatureFlag';

const EmployeesManagement = () => {
  const [activeTab, setActiveTab] = useState('list'); // 'list' | 'create' | 'conges'// 'list' ou 'create'
  const { isEnabled: congesEnabled } = useFeatureFlag('gestion_conges')

  const handleEmployeeCreated = () => {
    // Quand un employé est créé, retourner à la liste
    setActiveTab('list');
  };

  return (
    <div className="min-h-screen p-6" style={{ backgroundColor: '#fdfcf5' }}>
      {/* En-tête moderne */}
      <div className="mb-4">

        <div className="flex items-center justify-between">
          <div className="mb-4">
            <h1 className="text-4xl font-bold mb-2" style={{ color: "#448696" }}>Ressources humaines</h1>

            <p className="text-gray-600 text-base font-medium">Gestion des profils, contrats et affectations</p>
          </div>
        </div>
      </div>

      {/* Onglets modernes */}
      <div className="mb-6">
        <div className="inline-flex gap-2 bg-white rounded-xl p-1.5 shadow-sm border border-gray-100">
          <button
            onClick={() => setActiveTab('list')}
            className={`flex items-center gap-2 px-6 py-3 font-semibold text-sm transition-all duration-200 rounded-lg ${activeTab === 'list' ? 'text-white shadow-md' : 'text-gray-600 hover:text-gray-900'
              }`}
            style={{
              backgroundColor: activeTab === 'list' ? '#448696' : 'transparent'
            }}
            onMouseEnter={(e) => {
              if (activeTab !== 'list') {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'list') {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
          >
            <List size={18} />
            Liste des employés
          </button>

          <button
            onClick={() => setActiveTab('create')}
            className={`flex items-center gap-2 px-6 py-3 font-semibold text-sm transition-all duration-200 rounded-lg ${activeTab === 'create' ? 'text-gray-900 shadow-md' : 'text-gray-600 hover:text-gray-900'
              }`}
            style={{
              backgroundColor: activeTab === 'create' ? '#fed774' : 'transparent'
            }}
            onMouseEnter={(e) => {
              if (activeTab !== 'create') {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== 'create') {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
          >
            <Plus size={18} />
            Créer un employé
          </button>


          {congesEnabled && (
            <button
              onClick={() => setActiveTab('conges')}
              className={`flex items-center gap-2 px-6 py-3 font-semibold text-sm transition-all duration-200 rounded-lg ${activeTab === 'conges' ? 'text-white shadow-md' : 'text-gray-600 hover:text-gray-900'
                }`}
              style={{ backgroundColor: activeTab === 'conges' ? '#0ea5e9' : 'transparent' }}
              onMouseEnter={(e) => { if (activeTab !== 'conges') e.currentTarget.style.backgroundColor = '#f3f4f6'; }}
              onMouseLeave={(e) => { if (activeTab !== 'conges') e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              <Calendar size={18} />
              Gestion des congés
            </button>
          )}

        </div>
      </div>

      {/* Contenu avec animation */}
      <div className="animate-fadeIn">
        {activeTab === 'conges' ? (
          <CongesModule />
        ) : activeTab === 'list' ? (
          <EmployeesList />
        ) : (
          <Newemployeeform
            onSuccess={handleEmployeeCreated}
            onClose={() => setActiveTab('list')}
          />
        )}
      </div>


      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default EmployeesManagement;